import React from 'react';

import { TopImpactStoryBubble } from '../shared/components/TopImpactStoryBubble';

import { useTopImpactStoriesDesktop } from './hooks/useTopImpactStoriesDesktop';

export const TopImpactStoriesDesktop: React.FC = () => {
	const {
		data: { desktopStories },
		actions: { trackStoryClick },
	} = useTopImpactStoriesDesktop();

	return (
		<div className="hidden grid-cols-5 gap-6 lg:mt-16 lg:grid xl:mt-36" data-testid="top-impact-stories-container">
			{desktopStories.map((story) => (
				<TopImpactStoryBubble key={story.key} story={story} trackStoryClick={trackStoryClick} />
			))}
		</div>
	);
};
